import { cn } from '@/lib/tailwind.utils'
import { SidebarAtom } from '@app/state/layoutAtom'
import { PanelRightClose, PanelRightOpen } from 'lucide-react'
import { useAtom } from 'jotai'
import { Separator } from '@/components/ui/separator'
import { Button } from '@/components/ui/button'

interface NavTriggerV2Props {
  className?: string
}

const NavTriggerV2 = ({ className }: NavTriggerV2Props) => {
  const [isOpen, setIsOpen] = useAtom(SidebarAtom)

  return (
    <div className={cn('flex items-center', className)}>
      <Button
        variant="ghost"
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="group relative flex h-8 w-8 items-center justify-center overflow-hidden rounded-md transition-colors group-data-[collapsible=icon]/sidebar-wrapper:hidden"
      >
        <PanelRightOpen
          className={cn(
            'absolute h-5 w-5 shrink-0 transition-all duration-300',
            'text-foreground/70',
            isOpen ? 'rotate-0 opacity-100 scale-100' : '-rotate-90 opacity-0 scale-75',
          )}
        />

        <PanelRightClose
          className={cn(
            'absolute h-5 w-5 shrink-0 transition-all duration-300',
            'text-foreground/70',
            !isOpen ? 'rotate-0 opacity-100 scale-100' : 'rotate-90 opacity-0 scale-75',
          )}
        />
      </Button>
      <Separator orientation="vertical" className="mx-2 data-[orientation=vertical]:h-4" />
    </div>
  )
}

export default NavTriggerV2
